var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolsMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1396_2074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33322 13.3335H13.3332V9.33346L8.66655 4.6668C10.1594 3.95383 11.8366 3.72121 13.4671 4.00096C15.0976 4.28072 16.6013 5.05909 17.7711 6.22889C18.9409 7.3987 19.7193 8.9024 19.9991 10.5329C20.2788 12.1635 20.0462 13.8406 19.3332 15.3335L27.3332 23.3335C27.8637 23.8639 28.1616 24.5833 28.1616 25.3335C28.1616 26.0836 27.8637 26.803 27.3332 27.3335C26.8028 27.8639 26.0834 28.1619 25.3332 28.1619C24.5831 28.1619 23.8637 27.8639 23.3332 27.3335L15.3332 19.3335C13.8404 20.0464 12.1632 20.2791 10.5327 19.9993C8.90216 19.7195 7.39846 18.9412 6.22865 17.7714C5.05884 16.6016 4.28047 15.0979 4.00072 13.4673C3.72096 11.8368 3.95358 10.1596 4.66655 8.6668L9.33322 13.3335Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1396_2074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolsMenuIcon);
export default __webpack_public_path__ + "static/media/tools-menu-icon.32cb96599cbb4795297b20306d61e626.svg";
export { ForwardRef as ReactComponent };